module.exports = __webpack_public_path__ + "media/images/games/35gender/tinied/cat-1f7967b717db209bb530dc43d9e633d2.png";